import React, { useState } from 'react'
import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { usePermissionRoles } from 'api/hooks/use-permission-roles'
import TableFooter from 'shared/tables/table-footer'

function RolesTab({ permissionId }) {
  const defaultParams = {
    permission_id: permissionId,
    page: 1,
    perPage: 25,
    isExpansive: true,
    status: 'active'
  }
  const [params, setParams] = useState(defaultParams)

  const { isSuccess, data: roles } = usePermissionRoles({ params })

  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm="auto">
                <div className="text-info">Roles</div>
              </Col>
              <Col sm="auto">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="show-non-zero-values"
                    onChange={(e) =>
                      setParams({ ...params, isExpansive: !params.isExpansive })
                    }
                    checked={params.isExpansive}
                  />
                  <label
                    className="form-check-label"
                    for="show-non-zero-values"
                  >
                    Expansive
                  </label>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Caption</th>
                  <th>Status</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {isSuccess &&
                  roles.data.map((role) => (
                    <tr>
                      <td>
                        <a
                          href={`/roles/${role.id}`}
                          rel="noreferrer"
                          target="_blank"
                        >
                          {role.name}
                        </a>
                      </td>
                      <td>{role.caption}</td>
                      <td>{role.status}</td>
                      <td>{role.permission_value}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>

        <div className="mt-4">
          {isSuccess && (
            <TableFooter
              meta={roles.meta}
              params={params}
              setParams={setParams}
            />
          )}
        </div>
      </Col>
    </Row>
  )
}

export default RolesTab
